import React from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import MainSidebar from "../../../Layout/MainSidebar";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import GriList from "./GriList";

const BRSRindex = () => {
  return (
    <MainDashboardLayout sidebar={<MainSidebar />}>
      <Unauthorized requiredModule="ESG Reporting | GRI">
        <GriList />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default BRSRindex;
